export default __webpack_public_path__ + "static/image-9-624f84565d597be71d53f357c93a4e53.jpg";